import React from 'react';
import { serviceCategories } from '../../data/siteContent';
import { CheckCircle2, ArrowRight } from 'lucide-react';
import { Badge, Card } from '../ui';

export const ServicesDetailSection: React.FC<{ onOpenConsultation?: () => void }> = ({ onOpenConsultation }) => {
  return (
    <section className="py-12 sm:py-14 lg:py-16 relative bg-[#f5f9fc] dark:bg-[#080e1a]">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10">
        <div className="text-center max-w-3xl mx-auto space-y-3 mb-10">
          <Badge variant="brand" className="px-3.5 py-1 text-xs uppercase tracking-wider">
            Detailed Breakdown
          </Badge>
          <h2 className="text-3xl sm:text-4xl font-extrabold text-[#184166] dark:text-white tracking-tight">
            Full Service Catalog & Line Items
          </h2>
          <p className="text-slate-600 dark:text-slate-400 text-sm">
            Deep dive into our specialized service divisions tailored to software, branding, sales support, and administrative execution.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
          {serviceCategories.map((cat, idx) => (
            <Card key={idx} variant="glass" className="p-6 sm:p-8 space-y-6 bg-white/95 dark:bg-[#0f1b2d] border border-slate-200 dark:border-slate-800">
              <h3 className="text-xl sm:text-2xl font-bold text-[#184166] dark:text-white tracking-tight border-b border-slate-200 dark:border-slate-800 pb-3">
                {cat.title}
              </h3>
              <div className="space-y-2.5">
                {cat.items.map((item, itemIdx) => (
                  <div key={itemIdx} className="flex items-start gap-2.5 text-xs sm:text-sm text-slate-700 dark:text-slate-300 font-medium">
                    <CheckCircle2 size={16} className="text-[#4a82c2] shrink-0 mt-0.5" />
                    <span>{item}</span>
                  </div>
                ))}
              </div>
              <div className="pt-4 border-t border-slate-200 dark:border-slate-800 flex items-center justify-end">
                <button
                  onClick={onOpenConsultation}
                  className="text-xs font-bold text-[#4a82c2] hover:text-[#08adae] flex items-center gap-1.5 transition-colors"
                >
                  <span>Inquire for {cat.title}</span> <ArrowRight size={14} />
                </button>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
